import React from 'react';
import { useNavigate } from 'react-router-dom'; // Use useNavigate instead of useHistory
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const CustomApplicationDevelopment = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path); // Navigate using React Router's navigate function
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Custom Application Development</h1>
                        <p className="tagline">
                            Innovative, Scalable & Secure Software Solutions
                        </p>
                    </header>
                    
                    <section className="introduction">
                        <p>
                        At EncryptArx, we develop custom apps for your unique business needs. Whatever it may be-web app, mobile app, software solution, or hybrid application-we believe in building scalable and high-performing solutions serving your purpose.
                        </p>
                    </section>
                    
                    <section className="why-choose-us">
                        <h2>Why Choose Us?</h2>
                        <p>
                        In the fast-paced digital landscape of today's world, custom applications enable your business to stand out among its competitors. Off-the-shelf solutions may not include features to suit unique needs. Our applications shall be scalable, flexible, and secure, ensuring that you are miles ahead.
                        </p>
                    </section>
                    
                    <section className="tech-stack">
                        <h2>Our Technology Stack</h2>
                        <p>
                        We build systems based on world-class technologies and secure coding practices:
                        </p>
                        <ul>
                            <li><strong>Agile Methodology:</strong> Delivering incremental value and quick adaptations.</li>
                            <li><strong>Cloud Computing:</strong> Harnessing AWS, Azure, and Google Cloud for global scalability.</li>
                            <li><strong>Microservices Architecture:</strong> Building modular solutions that are easy to maintain.</li>
                            <li><strong>AI & Machine Learning:</strong> Enhancing user experiences with smart, data-driven insights.</li>
                        </ul>
                    </section>
                    
                    <section className="secure-practices">
                        <h2>Secure Coding Practices</h2>
                        <p>
                        The security layers are inbuilt in our development process. We are compliant with industry standards such as OWASP guidelines, perform regular security audits, and apply robust encryption protocols for protecting your data. 
                        </p>
                    </section>
                    
                    <section className="services">
                        <h2>Our Services</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>WebApp Development</h3>
                                <p>Build dynamic, responsive web applications that engage users and drive growth.</p>
                                <button className="learn-more" onClick={() => handleNavigation('/contact')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Mobile App Development</h3>
                                <p>Create intuitive mobile applications for iOS and Android with seamless performance.</p>
                                <button className="learn-more" onClick={() => handleNavigation('/contact')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Software Development</h3>
                                <p>Develop custom software solutions that streamline operations and boost productivity.</p>
                                <button className="learn-more" onClick={() => handleNavigation('/contact')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Hybrid App Development</h3>
                                <p>Combine web and mobile capabilities to deliver versatile, cross-platform applications.</p>
                                <button className="learn-more" onClick={() => handleNavigation('/contact')}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default CustomApplicationDevelopment;
